import React from 'react';
import { motion } from 'framer-motion';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ContactHero() {
  return <section className="pt-16 pb-12 px-4 bg-gradient-to-b from-blue-50 to-white" data-id="element-410">
      <div className="max-w-6xl mx-auto text-center" data-id="element-411">
        <motion.div initial="hidden" animate="visible" variants={fadeIn} className="space-y-6" data-id="element-412">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-[#0f1f3d] mb-4" data-id="element-413">
            Contact Us
          </h1>
          <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full mb-6" data-id="element-414"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-415">
            Get in touch with us today. We're here to answer your questions and
            help you get started.
          </p>
        </motion.div>
      </div>
    </section>;
}